import { render } from "./Choice.vue?vue&type=template&id=170c28fc&scoped=true&ts=true"
import script from "./Choice.vue?vue&type=script&lang=ts"
export * from "./Choice.vue?vue&type=script&lang=ts"

import "./Choice.vue?vue&type=style&index=0&id=170c28fc&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170c28fc"]])

export default __exports__